export default {
  computed: {
    schema() {
      return {
        1: this.schemaIht1,
        2: this.schemaIht2,
        3: this.schemaIht3,
        4: this.schemaIhtBuka,
        5: this.schemaIhtTutup,
        6: this.schemaIhtAwal,
        7: this.schemaIhtAkhir,
      };
    },

    mMonevAlasanPsp() {
      let result = [];
      const alasans = {
        2: [1, 2, 9],
        3: [1, 9],
      };

      for (const kAlasan in this.masters.monev_alasan_psp || {}) {
        if (alasans[3].includes(+kAlasan)) {
          result.push({
            text: this.masters.monev_alasan_psp[kAlasan],
            value: +kAlasan,
          });
        }
      }

      return result;
    },

    schemaIht1() {
      return [
        {
          title: '<strong style="font-size: 18px">Form Kegiatan</strong>',
          grid: 12,
          instrumen: [
            {
              type: 'VDatePicker',
              name: 'tgl_monev',
              label: 'Tanggal Pelaksanaan IHT',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['tgl_monev'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'nama',
              label: 'Nama Pelapor',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              disabled: true,
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'sekolah',
              label: 'Nama Satuan Pendidikan/Sekolah',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              disabled: true,
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'kota',
              label: 'Kota/Kabupaten Satuan Pendidikan/Sekolah',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              disabled: true,
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VSelect',
              name: 'k_monev_moda_psp',
              label: 'Moda Penyelenggaraan IHT',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['k_monev_moda_psp'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              items: this.$mapForMaster(this.masters.monev_moda_psp || {}),
              itemText: 'text',
              itemValue: 'value',
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextarea',
              name: 'instrumen-psp_1',
              label: 'Latar Belakang dan Tujuan Kegiatan',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_1'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 3,
            },
          ],
        },
        {
          title: '<strong style="font-size: 18px">Sasaran</strong> (Orang)',
          grid: 6,
          instrumen: [
            {
              type: 'VTextField',
              name: 'jml_guru_mapel',
              label: 'Jumlah Guru Mapel',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['jml_guru_mapel'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, sm: 12, md: 4 },
              mask: '######',
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'jml_guru_bk',
              label: 'Jumlah Guru BK',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['jml_guru_bk'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, sm: 12, md: 4 },
              mask: '######',
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              show: { status: this.isKejuruan },
              type: 'VTextField',
              name: 'jml_guru_kejuruan',
              label: 'Jumlah Guru Kejuruan',
              labelColor:
                this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['jml_guru_kejuruan'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, sm: 12, md: 4 },
              mask: '######',
              outlined: true,
              dense: true,
              singleLine: true,
            },
          ],
        },
        {
          title: '<strong style="font-size: 18px">Undangan yang Hadir</strong> (Orang)',
          grid: 6,
          instrumen: [
            {
              type: 'VTextField',
              name: 'jml_hadir_upt',
              label: 'Jml. Perwakilan UPT',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['jml_hadir_upt'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, sm: 12, md: 4 },
              mask: '######',
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'jml_hadir_dinas',
              label: 'Jml. Perwakilan Dinas',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['jml_hadir_dinas'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, sm: 12, md: 4 },
              mask: '######',
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'jml_hadir_pengawas',
              label: 'Jml. Pengawas Sekolah',
              labelColor:
                this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['jml_hadir_pengawas'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, sm: 12, md: 4 },
              mask: '######',
              outlined: true,
              dense: true,
              singleLine: true,
            },
          ],
        },
        {
          title: '<strong style="font-size: 18px">Form Evaluasi</strong>',
          grid: 12,
          instrumen: [
            {
              type: 'VTextarea',
              name: 'instrumen-psp_2',
              label: 'Kendala apa yang terjadi atau hal yang perlu diperbaiki dalam proses pelaksanaan IHT?',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_2'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 3,
            },
            {
              type: 'VTextarea',
              name: 'instrumen-psp_3',
              label:
                'Hal baik apa yang sudah terjadi selama IHT? (misalnya dari sisi pelaksanaan kegiatan, keaktifan/partisipasi peserta, keterampilan dalam menggunakan perangkat ajar, kemampuan peserta dalam pemahaman materi, atau hal lain yang berkaitan dengan IHT)',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_3'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 3,
            },
          ],
        },
        {
          title: '<strong style="font-size: 18px">Form Kegiatan</strong>',
          grid: 12,
          type: 'File',
          instrumen: [
            {
              id: 1,
              type: 'File',
              name: 'file_dok1',
              label: 'Pembukaan Kegiatan',
            },
            {
              id: 2,
              type: 'File',
              name: 'file_dok2',
              label: 'Pelaksanaan Kegiatan',
            },
            {
              id: 3,
              type: 'File',
              name: 'file_dok3',
              label: 'Pentutupan Kegiatan',
            },
          ],
        },
      ];
    },

    schemaIht2() {
      return [
        {
          title: '<strong style="font-size: 18px">Form Kegiatan</strong>',
          grid: 12,
          instrumen: [
            {
              type: 'VDatePicker',
              name: 'tgl_monev',
              label: 'Tanggal Pelaksanaan IHT',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['tgl_monev'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'nama',
              label: 'Nama Pelapor',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              disabled: true,
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'sekolah',
              label: 'Nama Satuan Pendidikan/Sekolah',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              disabled: true,
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'kota',
              label: 'Kota/Kabupaten Satuan Pendidikan/Sekolah',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              disabled: true,
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VSelect',
              name: 'k_monev_moda_psp',
              label: 'Moda Penyelenggaraan IHT',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['k_monev_moda_psp'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              items: this.$mapForMaster(this.masters.monev_moda_psp || {}),
              itemText: 'text',
              itemValue: 'value',
              outlined: true,
              dense: true,
              singleLine: true,
            },
          ],
        },
        {
          title: '<strong style="font-size: 18px">Form Evaluasi</strong>',
          grid: 12,
          instrumen: [
            {
              type: 'VTextarea',
              name: 'instrumen-psp_2',
              label: 'Kendala apa yang terjadi atau hal yang perlu diperbaiki dalam proses pelaksanaan IHT?',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_2'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 3,
            },
            {
              type: 'VTextarea',
              name: 'instrumen-psp_3',
              label:
                'Hal baik apa yang sudah terjadi selama IHT? (misalnya dari sisi pelaksanaan kegiatan, keaktifan/partisipasi peserta, keterampilan dalam menggunakan perangkat ajar, kemampuan peserta dalam pemahaman materi, atau hal lain yang berkaitan dengan IHT)',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_3'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 3,
            },
          ],
        },
        {
          title: '<strong style="font-size: 18px">Dokumentasi Kegiatan</strong>',
          grid: 12,
          type: 'File',
          instrumen: [
            {
              id: 1,
              type: 'File',
              name: 'file_dok1',
              label: 'Foto Kegiatan',
            },
            {
              id: 2,
              type: 'File',
              name: 'file_dok2',
              label: 'Foto Kegiatan',
            },
            {
              id: 3,
              type: 'File',
              name: 'file_dok3',
              label: 'Foto Kegiatan',
            },
          ],
        },
      ];
    },

    schemaIht3() {
      return {
        1: [
          {
            title: '<strong style="font-size: 18px">Form Kegiatan</strong>',
            grid: 12,
            instrumen: [
              {
                type: 'VTextField',
                name: 'nama',
                label: 'Nama Pelapor',
                labelColor: 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12, md: 6 },
                disabled: true,
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VTextField',
                name: 'sekolah',
                label: 'Nama Satuan Pendidikan/Sekolah',
                labelColor: 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12, md: 6 },
                disabled: true,
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VTextField',
                name: 'kota',
                label: 'Kota/Kabupaten Satuan Pendidikan/Sekolah',
                labelColor: 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12, md: 12 },
                disabled: true,
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VDatePicker',
                name: 'tgl_monev',
                label: 'Tanggal Pelaksanaan',
                labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['tgl_monev'] ? 'red' : 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12, md: 6 },
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VSelect',
                name: 'k_monev_moda_psp',
                label: 'Moda Penyelenggaraan IHT',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['k_monev_moda_psp'] ? 'red' : 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12, md: 6 },
                items: this.$mapForMaster(this.masters.monev_moda_psp || {}),
                itemText: 'text',
                itemValue: 'value',
                outlined: true,
                dense: true,
                singleLine: true,
              },
            ],
          },
          {
            title: '<strong style="font-size: 18px">Sasaran</strong> (Orang)',
            grid: 6,
            instrumen: [
              {
                type: 'VTextField',
                name: 'jml_guru_mapel',
                label: 'Jumlah Guru Mapel',
                labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['jml_guru_mapel'] ? 'red' : 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12, sm: 12, md: 4 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VTextField',
                name: 'jml_guru_bk',
                label: 'Jumlah Guru BK',
                labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['jml_guru_bk'] ? 'red' : 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12, sm: 12, md: 4 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                show: { status: this.isKejuruan },
                type: 'VTextField',
                name: 'jml_guru_kejuruan',
                label: 'Jumlah Guru Kejuruan',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['jml_guru_kejuruan'] ? 'red' : 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12, sm: 12, md: 4 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
              },
            ],
          },
          {
            title: '<strong style="font-size: 18px">Undangan yang Hadir</strong> (Orang)',
            grid: 6,
            instrumen: [
              {
                type: 'VTextField',
                name: 'jml_hadir_upt',
                label: 'Jml. Perwakilan UPT',
                labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['jml_hadir_upt'] ? 'red' : 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12, sm: 12, md: 4 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VTextField',
                name: 'jml_hadir_dinas',
                label: 'Jml. Perwakilan Dinas',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['jml_hadir_dinas'] ? 'red' : 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12, sm: 12, md: 4 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VTextField',
                name: 'jml_hadir_pengawas',
                label: 'Jml. Pengawas Sekolah',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['jml_hadir_pengawas'] ? 'red' : 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12, sm: 12, md: 4 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
              },
            ],
          },
          {
            title: '',
            grid: 12,
            instrumen: [
              {
                type: 'VTextarea',
                name: 'instrumen-psp_2',
                label: 'Kendala apa yang terjadi atau hal yang perlu diperbaiki dalam proses pelaksanaan IHT?',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_2'] ? 'red' : 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12 },
                outlined: true,
                dense: true,
                singleLine: true,
                rows: 3,
                counter: 1500,
              },
              {
                type: 'VTextarea',
                name: 'instrumen-psp_3',
                label:
                  'Hal baik apa yang sudah terjadi selama IHT? (misalnya dari sisi pelaksanaan kegiatan, keaktifan/partisipasi peserta, keterampilan dalam menggunakan perangkat ajar, kemampuan peserta dalam pemahaman materi, atau hal lain yang berkaitan dengan IHT)',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_3'] ? 'red' : 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12 },
                outlined: true,
                dense: true,
                singleLine: true,
                rows: 3,
                counter: 1000,
              },
            ],
          },
          {
            title: '<strong style="font-size: 18px">Foto Kegiatan</strong>',
            grid: 12,
            type: 'File',
            instrumen: [
              {
                id: 1,
                type: 'File',
                name: 'file_dok1',
                label: 'Penutup Kegiatan',
              },
              {
                id: 2,
                type: 'File',
                name: 'file_dok2',
                label: 'Pelaksanaan Kegiatan',
              },
              {
                id: 3,
                type: 'File',
                name: 'file_dok3',
                label: 'Pembukaan Kegiatan',
              },
            ],
          },
        ],
        2: [
          {
            title:
              '<strong style="font-size: 18pt">Rekapitulasi pre test dan post peserta IHT</strong>' +
              '<br/> Bisa ditambahkan sesuai dengan kebutuhan max 25 guru',
            grid: 12,
            type: 'peserta',
          },
        ],
        3: [
          {
            title:
              '<strong style="font-size: 18px"> Rekapitulasi Instrumen evaluasi penyelenggaraan IHT</strong>' +
              '<br/> Isikan <b>jumlah data</b> instrumen berikut berdasarkan kategori <b>Sangat Tidak Setuju, ' +
              'Tidak Setuju, Setuju, </b> dan <b>Sangat Setuju</b>',
            grid: 12,
            type: 'rekapitulasi',
            childs: [
              {
                label: 'I. Instrumen Umpan Balik Pengajar IHT',
                children: [
                  {
                    label: 'Persepsi Terkait Metode IHT',
                    items: {
                      1: 'Penyampaian materi yang diberikan menarik',
                      2: 'Pengajar menguasai materi IHT',
                      3: 'Pengajar mampu menyampaikan materi sehingga mudah dipahami.',
                      4: 'Pengajar memberikan umpan balik (feedback) yang membantu peserta untuk lebih memahami materi yang diajarkan',
                      5: 'Pengajar memberikan kesempatan bertanya dan berdiskusi.',
                      6: 'Pengajar melakukan asesmen yang dilakukan oleh pengajar sesuai dengan tujuan IHT',
                      7: 'Pengajar memiliki manajemen waktu pembelajaran yang baik',
                      8: 'Pengajar mampu menjawab pertanyaan-pertanyaan yang diajukan oleh peserta IHT',
                      9: 'Pengajar mampu memberikan motivasi kepada peserta IHT',
                    },
                  },
                ],
              },
              {
                label: 'II. Instrumen Umpan Balik Proses Penyelenggaraan IHT',
                children: [
                  {
                    label: 'Persepsi terkait Metode IHT',
                    items: {
                      10: 'Metode kombinasi antara synchronous (terstruktur) dan asynchronous (mandiri) dapat secara efektif meningkatkan pemahaman dan keterampilan.',
                      11: 'Secara umum, durasi pelaksanaan IHT dengan metode terstruktur (synchronous) efisien.',
                      12: 'Secara umum, durasi pelaksanaan IHT dengan metode mandiri (asynchronous) efisien.',
                      13: 'Kegiatan praktik dalam pelaksanaan IHT memiliki kesesuaian dengan konsep/teori yang diajarkan.',
                      14: 'Teknik penyampaian materi melalui eksplorasi konsep yang dilanjutkan dengan diskusi (pembelajaran alur merdeka) memudahkan saya dalam memahami materi IHT',
                    },
                  },
                  {
                    label: 'Perangkat Ajar IHT',
                    items: {
                      15: 'Panduan IHT yang diberikan berisi informasi yang dibutuhkan oleh peserta',
                      16: 'Modul IHT mudah untuk diakses/diunduh.',
                      17: 'Platform pembelajaran yang digunakan untuk proses IHT mudah untuk digunakan (user friendly).',
                      18: 'Platform pembelajaran IHT membantu saya memahami materi.',
                      19: 'Platform pembelajaran IHT membantu saya mengikuti keseluruhan proses IHT.',
                      20: 'Platform pembelajaran IHT memberikan informasi tentang umpan balik (feedback) dari pengajar sehingga membantu meningkatkan pengetahuan dan keterampilan saya.',
                    },
                  },
                  {
                    label: 'Substansi/Materi IHT',
                    items: {
                      21: 'Secara umum, materi IHT cukup mudah dipahami',
                      22: 'Materi IHT menyiapkan saya dalam meningkatkan kualitas pembelajaran kepada peserta didik',
                      23: 'Materi IHT dapat menjawab permasalahan di tingkat satuan pendidikan',
                    },
                  },
                ],
              },
            ],
            schema: [
              {
                type: 'VTextField',
                name: 'n1',
                label: 'Sangat Tidak Setuju',
                labelColor: 'red',
                grid: { cols: 12, sm: 12, md: 3 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
                hideDetails: true,
              },
              {
                type: 'VTextField',
                name: 'n2',
                label: 'Tidak Setuju',
                labelColor: 'warning',
                grid: { cols: 12, sm: 12, md: 3 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VTextField',
                name: 'n3',
                label: 'Setuju',
                labelColor: 'blue',
                grid: { cols: 12, sm: 12, md: 3 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VTextField',
                name: 'n4',
                label: 'Sangat Setuju',
                labelColor: 'green',
                grid: { cols: 12, sm: 12, md: 3 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
              },
            ],
          },
        ],
        4: [
          {
            title:
              '<strong style="font-size: 18px"> Form Evaluasi Peserta IHT</strong> <br/> ' +
              '<span class="grey--text">(Isi bagian ini dengan hasil olahan lembar yang diisi oleh peserta IHT)</span>',
            grid: 12,
            instrumen: [
              {
                type: 'VTextarea',
                name: 'instrumen-psp_4',
                label:
                  'Secara garis besar, deskripsikan presepsi terkait metode pelaksanaan IHT yang dilakukan di sekolah / satuan Pendidikan ?',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_4'] ? 'red' : 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12, sm: 12, md: 12 },
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VTextarea',
                name: 'instrumen-psp_5',
                label:
                  'Secara garis besar, bagaimana persepsi peserta terhadap ketepatan perangkat ajar yang digunakan dalam IHT dalam membantu pemahaman mereka ?',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_5'] ? 'red' : 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12, sm: 12, md: 12 },
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VTextarea',
                name: 'instrumen-psp_6',
                label:
                  'Apakah materi IHT yang disampaikan dapat dipahami dan menjawab permasalahan di tingkat Pendidikat / sekolah ?',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_6'] ? 'red' : 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12, sm: 12, md: 12 },
                outlined: true,
                dense: true,
                singleLine: true,
              },
            ],
          },
          {
            title: '<strong style="font-size: 18px">Hambatan dan Dukungan</strong>',
            grid: 12,
            children: [
              {
                grid: 6,
                label:
                  'Jenis Hambatan apa yang paling sering ditemui peserta pelatihan selama proses IHT? <i>(jawaban boleh lebih dari satu)</i>',
                instrumen: [
                  {
                    id: '1',
                    type: 'Checkbox',
                    name: 'opsi-psp_7_1',
                    value: 1,
                    trueValue: 1,
                    falseValue: '',
                    label: 'Tidak memiliki cukup waktu untuk mengikuti IHT',
                    labelColor: 'black',
                    hint: 'wajib diisi',
                    hideDetails: true,
                    class: ['mt-0', 'pt-1', 'pb-0'],
                    grid: { cols: 12 },
                  },
                  {
                    id: '2',
                    type: 'Checkbox',
                    name: 'opsi-psp_7_2',
                    value: 2,
                    trueValue: 2,
                    falseValue: '',
                    label: 'Tidak memiliki perangkat yang memadai',
                    labelColor: 'black',
                    hint: 'wajib diisi',
                    hideDetails: true,
                    class: ['mt-0', 'pt-1', 'pb-0'],
                    grid: { cols: 12 },
                  },
                  {
                    id: '3',
                    type: 'Checkbox',
                    name: 'opsi-psp_7_3',
                    value: 3,
                    trueValue: 3,
                    falseValue: '',
                    label: 'Berada di wilayah yang memiliki jaringan internet kurang memadai ',
                    labelColor: 'black',
                    hint: 'wajib diisi',
                    hideDetails: true,
                    class: ['mt-0', 'pt-1', 'pb-0'],
                    grid: { cols: 12 },
                  },
                  {
                    type: 'Checkbox',
                    name: 'opsi-psp_7_4',
                    value: 4,
                    trueValue: 4,
                    falseValue: '',
                    label: 'Berada di wilayah yang memiliki jaringan listrik kurang memadai',
                    labelColor: 'black',
                    hint: 'wajib diisi',
                    hideDetails: true,
                    class: ['mt-0', 'pt-1', 'pb-0'],
                    grid: { cols: 12 },
                  },
                  {
                    type: 'Checkbox',
                    name: 'opsi-psp_7_5',
                    value: 5,
                    trueValue: 5,
                    falseValue: '',
                    label: 'Kesulitan dalam menggunakan platform belajar',
                    labelColor: 'black',
                    hint: 'wajib diisi',
                    hideDetails: true,
                    class: ['mt-0', 'pt-1', 'pb-0'],
                    grid: { cols: 12 },
                  },
                  {
                    type: 'Checkbox',
                    name: 'opsi-psp_7_6',
                    value: 6,
                    trueValue: 6,
                    falseValue: '',
                    label: 'Tidak mendapat dukungan lingkungan tempat saya bertugas untuk mengikuti proses IHT',
                    labelColor: 'black',
                    hint: 'wajib diisi',
                    hideDetails: true,
                    class: ['mt-0', 'pt-1', 'pb-0'],
                    grid: { cols: 12 },
                  },
                  {
                    type: 'Checkbox',
                    name: 'opsi-psp_7_7',
                    value: 7,
                    trueValue: 7,
                    falseValue: '',
                    label: 'Tidak mendapat dukungan dari keluarga untuk mengikuti proses IHT',
                    labelColor: 'black',
                    hint: 'wajib diisi',
                    hideDetails: true,
                    class: ['mt-0', 'pt-1', 'pb-0'],
                    grid: { cols: 12 },
                  },
                  {
                    type: 'Checkbox',
                    name: 'opsi-psp_7_8',
                    value: 8,
                    trueValue: 8,
                    falseValue: '',
                    label: 'Tidak ada',
                    labelColor: 'black',
                    hint: 'wajib diisi',
                    hideDetails: true,
                    class: ['mt-0', 'pt-1', 'pb-0'],
                    grid: { cols: 12 },
                  },
                  {
                    type: 'Checkbox',
                    name: 'opsi-psp_7_9',
                    value: 9,
                    trueValue: 9,
                    falseValue: '',
                    label: 'Lainnya',
                    labelColor: 'black',
                    hint: 'wajib diisi',
                    hideDetails: true,
                    class: ['mt-0', 'pt-1'],
                    grid: { cols: 12 },
                  },
                ],
              },
              {
                grid: 6,
                label:
                  'Jenis Dukungan yang paling banyak diperlukan oleh peserta IHT agar proses IHT semakin baik? <i>(jawaban boleh lebih dari satu)</i>',
                instrumen: [
                  {
                    type: 'Checkbox',
                    name: 'opsi-psp_8_10',
                    value: 10,
                    trueValue: 10,
                    falseValue: '',
                    label:
                      'Penambahan durasi pelaksanaan IHT  untuk meningkatkan pengetahuan dan keterampilan sebagai guru/ pemimpin pembelajaran di dalam kelas',
                    labelColor: 'black',
                    hint: 'wajib diisi',
                    hideDetails: true,
                    class: ['mt-0', 'pt-1', 'pb-0'],
                    grid: { cols: 12 },
                  },
                  {
                    type: 'Checkbox',
                    name: 'opsi-psp_8_11',
                    value: 11,
                    trueValue: 11,
                    falseValue: '',
                    label: 'Pengenalan platform pembelajaran yang akan digunakan',
                    labelColor: 'black',
                    hint: 'wajib diisi',
                    hideDetails: true,
                    class: ['mt-0', 'pt-1', 'pb-0'],
                    grid: { cols: 12 },
                  },
                  {
                    type: 'Checkbox',
                    name: 'opsi-psp_8_12',
                    value: 12,
                    trueValue: 12,
                    falseValue: '',
                    label: 'Sarana dan prasarana pelaksanaan IHT',
                    labelColor: 'black',
                    hint: 'wajib diisi',
                    hideDetails: true,
                    class: ['mt-0', 'pt-1', 'pb-0'],
                    grid: { cols: 12 },
                  },
                  {
                    type: 'Checkbox',
                    name: 'opsi-psp_8_13',
                    value: 13,
                    trueValue: 13,
                    falseValue: '',
                    label: 'Tidak ada',
                    labelColor: 'black',
                    hint: 'wajib diisi',
                    hideDetails: true,
                    class: ['mt-0', 'pt-1', 'pb-0'],
                    grid: { cols: 12 },
                  },
                  {
                    type: 'Checkbox',
                    name: 'opsi-psp_8_14',
                    value: 14,
                    trueValue: 14,
                    falseValue: '',
                    label: 'Lainnya',
                    labelColor: 'black',
                    hint: 'wajib diisi',
                    hideDetails: true,
                    class: ['mt-0', 'pt-1'],
                    grid: { cols: 12 },
                  },
                ],
              },
            ],
          },
        ],
        5: [
          {
            title: '<strong style="font-size: 18px">Dokumen Administrasi Kegiatan IHT</strong>',
            grid: 12,
            type: 'File',
            instrumen: [
              {
                id: 4,
                type: 'File',
                name: 'file_presensi',
                label: 'Dokumen Presensi Peserta selama proses kegiatan IHT',
              },
              {
                id: 5,
                type: 'File',
                name: 'file_konsumsi',
                label: 'Dokumen kuitansi konsumsi selama proses kegiatan IHT',
              },
            ],
          },
        ],
      };
    },

    schemaIhtBuka() {
      if (this.isSmkPk) {
        return this.schemaIhtBukaSmkPk;
      }

      let kelompok = [];
      let kelompokMapels = {};

      for (const mapelId in this.mapels) {
        const mapel = this.mapels[mapelId];
        const namaKelompok = mapel[2] || `Jenjang ${this.$getDeepObj(this.detail, 'sekolah.m_jenjang.singkat')}`;
        const id = kelompok.indexOf(namaKelompok);

        if (id === -1) {
          kelompok.push(namaKelompok);
          kelompokMapels[kelompok.indexOf(namaKelompok)] = [];
        }

        kelompokMapels[kelompok.indexOf(namaKelompok)].push({
          type: 'VTextField',
          name: `mapel-${mapelId}`,
          label: mapel[0],
          labelColor:
            this.$getDeepObj(this.detail, 'tgl_monev') &&
            !this.form[`mapel-${mapelId}`] &&
            this.form[`mapel-${mapelId}`] !== 0
              ? 'red'
              : 'grey',
          hint: 'wajib diisi',
          placeholder: 'Tuliskan jumlah guru',
          mask: '###',
          grid: { cols: 12, md: 3 },
          outlined: true,
          dense: true,
          singleLine: true,
        });
      }

      let result = [
        {
          jenis_instrumen: 'awal',
          title: '<strong style="font-size: 18px">Form Kegiatan</strong>',
          grid: 12,
          instrumen: [
            {
              type: 'textView',
              label: `Nama Pelapor`,
              labelColor: 'grey',
              value: this.$getDeepObj(this.detail, 'ptk.nama') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `Nama Satuan Pendidikan/Sekolah`,
              labelColor: 'grey',
              value: this.$getDeepObj(this.detail, 'sekolah.nama') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `Kota/Kabupaten Satuan Pendidikan/Sekolah`,
              labelColor: 'grey',
              value: this.$getDeepObj(this.detail, 'sekolah.m_kota.keterangan') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'VRadio',
              name: 'is_terlaksana',
              label: 'Apakah menyelenggarakan IHT di satuan pendidikan?',
              labelColor: 'grey',
              hint: 'wajib diisi',
              required: true,
              items: [
                { text: 'Ya', value: '1' },
                { text: 'Tidak', value: '0' },
              ],
              grid: { cols: 12, md: 6 },
            },
            {
              show: { status: +this.form.is_terlaksana === 1 },
              type: 'VDatePicker',
              name: 'tgl_monev',
              label: 'Tanggal Pembukaan IHT',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              show: { status: +this.form.is_terlaksana === 1 },
              type: 'VSelect',
              name: 'k_monev_moda_psp',
              label: 'Moda Penyelenggaraan IHT',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              items: this.$mapForMaster(this.masters.monev_moda_psp || {}),
              itemText: 'text',
              itemValue: 'value',
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              show: { status: +this.form.is_terlaksana === 0 },
              type: 'VSelect',
              name: 'k_monev_alasan_psp',
              label: 'Alasan tidak menyelenggarakan IHT',
              labelColor:
                this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['k_monev_alasan_psp'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              items: this.$mapForMaster(this.masters.monev_alasan_psp || {}),
              itemText: 'text',
              itemValue: 'value',
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              show: { status: +this.form.is_terlaksana === 0 && +this.form.k_monev_alasan_psp === 9 },
              type: 'VTextField',
              name: 'alasan_lain',
              label: 'Alasan lainnya tidak menyelenggarakan IHT',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['alasan_lain'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
            },
          ],
        },
      ];

      if (+this.form.is_terlaksana === 1) {
        for (const idKelompok in kelompok) {
          if (kelompok[idKelompok] && kelompokMapels[idKelompok]) {
            result.push({
              title: +idKelompok === 0 ? '<strong style="font-size: 18px">Sasaran IHT</strong>' : '',
              subtitle: [
                `<div class="body-1 font-weight-medium ${+idKelompok === 0 ? 'mt-4' : ''}">${this.$numberToAlpha(
                  idKelompok
                )}. ${kelompok[idKelompok]} (Jumlah Guru Mapel)</div>`,
                `<div class="body-2">Jika tidak ada guru mata pelajaran yang mengikuti, isikan angka 0 pada kolom</div>`,
              ].join(''),
              grid: 12,
              instrumen: kelompokMapels[idKelompok],
            });
          }
        }
      }

      if (+this.form.is_terlaksana === 1) {
        result.push({
          title: '<strong style="font-size: 18px">Dokumentasi Pembukaan IHT</strong>',
          grid: 12,
          type: 'File',
          instrumen: [
            {
              id: 1,
              type: 'File',
              name: 'file_dok1',
              label: 'Foto Kegiatan',
            },
            {
              id: 2,
              type: 'File',
              name: 'file_dok2',
              label: 'Foto Kegiatan',
            },
            {
              id: 3,
              type: 'File',
              name: 'file_dok3',
              label: 'Foto Kegiatan',
            },
          ],
        });

        result.push({
          title: '<strong style="font-size: 18px">Dokumentasi absensi IHT</strong>',
          grid: 12,
          type: 'File',
          instrumen: [
            {
              id: 4,
              type: 'File',
              name: 'file_presensi',
              label: 'Dokumentasi Absensi',
            },
          ],
        });

        result.push({
          title: '',
          type: 'link',
          instrumen: [
            {
              type: 'link',
              color: 'blue',
              content: [
                '<h2 class="black--text">Informasi Tambahan</h2>',
                `<p class="black--text mt-2">Untuk mengakses tautan pre tast sesuai UPT Anda, silakan akses pada <a href="${this
                  .detail && this.detail.url_pretest}" target="_blank">${this.detail &&
                  this.detail.url_pretest}</a></p>`,
              ].join(''),
            },
          ],
        });
      }

      return result;
    },

    schemaIhtTutup() {
      if (this.isSmkPk) {
        return this.schemaIhtTutupSmkPk;
      }

      return [
        {
          title: '<strong style="font-size: 18px">Form Kegiatan</strong>',
          grid: 12,
          instrumen: [
            {
              type: 'textView',
              label: `Nama Pelapor`,
              labelColor: 'grey',
              value: this.$getDeepObj(this.detail, 'ptk.nama') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `Nama Satuan Pendidikan/Sekolah`,
              labelColor: 'grey',
              value: this.$getDeepObj(this.detail, 'sekolah.nama') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `Kota/Kabupaten Satuan Pendidikan/Sekolah`,
              labelColor: 'grey',
              value: this.$getDeepObj(this.detail, 'sekolah.m_kota.keterangan') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'VDatePicker',
              name: 'tgl_monev',
              label: 'Tanggal Penutupan IHT',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextarea',
              name: 'instrumen-psp_1',
              label: 'Latar belakang dan tujuan kegiatan',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_1'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 3,
              autoGrow: true,
            },
          ],
        },
        {
          title: [
            '<strong style="font-size: 18px">Pihak Luar Satuan Pendidikan yang Hadir (Jumlah Orang)</strong>',
            '<span class="body-2">Jika tidak ada perwakilan pihak terkait yang mengikuti, isikan angka 0 pada kolom</span>',
          ].join('<br>'),
          grid: 12,
          instrumen: [
            {
              type: 'VTextField',
              name: 'jml_hadir_dinas',
              label: 'Perwakilan Dinas Pendidikan',
              labelColor:
                this.$getDeepObj(this.detail, 'tgl_monev') &&
                !this.form['jml_hadir_dinas'] &&
                this.form['jml_hadir_dinas'] !== 0
                  ? 'red'
                  : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, sm: 12, md: 3 },
              mask: '######',
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'jml_hadir_pengawas',
              label: 'Jml. Pengawas Sekolah',
              labelColor:
                this.$getDeepObj(this.detail, 'tgl_monev') &&
                !this.form['jml_hadir_pengawas'] &&
                this.form['jml_hadir_pengawas'] !== 0
                  ? 'red'
                  : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, sm: 12, md: 3 },
              mask: '######',
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'jml_hadir_upt',
              label: 'Perwakilan UPT/BGP/BBGP',
              labelColor:
                this.$getDeepObj(this.detail, 'tgl_monev') &&
                !this.form['jml_hadir_upt'] &&
                this.form['jml_hadir_upt'] !== 0
                  ? 'red'
                  : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, sm: 12, md: 3 },
              mask: '######',
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'jml_hadir_fasilitator',
              label: 'Fasilitator Sekolah Penggerak',
              labelColor:
                this.$getDeepObj(this.detail, 'tgl_monev') &&
                !this.form['jml_hadir_fasilitator'] &&
                this.form['jml_hadir_fasilitator'] !== 0
                  ? 'red'
                  : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, sm: 12, md: 3 },
              mask: '######',
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VRadio',
              name: 'is_luar_hadir',
              label: 'Apakah ada pihak luar satuan pendidikan lainnya yang ikut hadir?',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['is_luar_hadir'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              required: true,
              items: [
                { text: 'Ya', value: '1' },
                { text: 'Tidak', value: '0' },
              ],
              grid: { cols: 12, md: 6 },
            },
            {
              show: { status: +this.form.is_luar_hadir === 1 },
              type: 'VTextField',
              name: 'nama_hadir_lain',
              label: 'Instansi pihak luar',
              labelColor:
                this.$getDeepObj(this.detail, 'tgl_monev') &&
                !this.form['nama_hadir_lain'] &&
                this.form['nama_hadir_lain'] !== 0
                  ? 'red'
                  : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, sm: 12, md: 3 },
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              show: { status: +this.form.is_luar_hadir === 1 },
              type: 'VTextField',
              name: 'jml_hadir_lain',
              label: 'Jumlah pihak luar lainnya',
              labelColor:
                this.$getDeepObj(this.detail, 'tgl_monev') &&
                !this.form['jml_hadir_lain'] &&
                this.form['jml_hadir_lain'] !== 0
                  ? 'red'
                  : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, sm: 12, md: 3 },
              mask: '###',
              outlined: true,
              dense: true,
              singleLine: true,
            },
          ],
        },
        {
          title:
            '<strong style="font-size: 18px">Hal-hal efektif dan tidak efektif terkait materi dan pelaksanaan IHT</strong>',
          grid: 12,
          instrumen: [
            {
              type: 'VTextarea',
              name: 'instrumen-psp_11',
              label: 'Hal-hal Efektif Terkait Konten/Materi',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_11'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 3,
              autoGrow: true,
            },
            {
              type: 'VTextarea',
              name: 'instrumen-psp_12',
              label: 'Hal-hal Efektif Terkait Pelaksanaan IHT',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_12'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 3,
              autoGrow: true,
            },
            {
              type: 'VTextarea',
              name: 'instrumen-psp_13',
              label: 'Hal-hal Tidak Efektif Terkait Konten/Materi',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_13'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 3,
              autoGrow: true,
            },
            {
              type: 'VTextarea',
              name: 'instrumen-psp_14',
              label: 'Hal-hal Tidak Efektif Terkait Pelaksanaan IHT',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_14'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 3,
              autoGrow: true,
            },
            {
              type: 'VTextarea',
              name: 'instrumen-psp_15',
              label: 'Rencana Tindak Lanjut IHT',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_15'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 3,
              autoGrow: true,
            },
          ],
        },
        {
          title: '<strong style="font-size: 18px">Dokumentasi Foto Proses IHT</strong>',
          grid: 12,
          type: 'File',
          instrumen: [
            {
              id: 1,
              type: 'File',
              name: 'file_dok1',
              label: 'Foto Kegiatan',
            },
            {
              id: 2,
              type: 'File',
              name: 'file_dok2',
              label: 'Foto Kegiatan',
            },
            {
              id: 3,
              type: 'File',
              name: 'file_dok3',
              label: 'Foto Kegiatan',
            },
          ],
        },
        {
          title: '<strong style="font-size: 18px">Dokumentasi absensi IHT</strong>',
          grid: 12,
          type: 'File',
          instrumen: [
            {
              id: 4,
              type: 'File',
              name: 'file_presensi',
              label: 'Dokumentasi Absensi',
            },
          ],
        },
        {
          title: '',
          type: 'link',
          instrumen: [
            {
              type: 'link',
              color: 'orange',
              content: [
                '<h2 class="black--text">Informasi Tambahan</h2>',
                '<ul style="padding-inline-start: 20px" class="mt-2">',
                `<li class="black--text">Untuk mengakses tautan <strong>post test</strong>, silakan akses pada <a href="${this
                  .detail && this.detail.url_posttest}" target="_blank">${this.detail &&
                  this.detail.url_posttest}</a></li>`,
                `<li class="black--text">Untuk mengakses tautan <strong>evaluasi</strong>, silakan akses pada <a href="${this
                  .detail && this.detail.url_evaluasi}" target="_blank">${this.detail &&
                  this.detail.url_evaluasi}</a></li>`,
                '</ul>',
              ].join(''),
              contentButton: 'evaluasi',
              link: (this.detail && this.detail.url_evaluasi) || '',
            },
          ],
        },
      ];
    },

    schemaIhtBukaSmkPk() {
      let kelompok = [];
      let kelompokMapels = {};

      for (const mapelId in this.mapels) {
        const mapel = this.mapels[mapelId];
        const namaKelompok = mapel[2] || `Jenjang ${this.$getDeepObj(this.detail, 'sekolah.m_jenjang.singkat')}`;
        const id = kelompok.indexOf(namaKelompok);

        if (id === -1) {
          kelompok.push(namaKelompok);
          kelompokMapels[kelompok.indexOf(namaKelompok)] = [];
        }

        kelompokMapels[kelompok.indexOf(namaKelompok)].push({
          type: 'VTextField',
          name: `mapel-${mapelId}`,
          label: mapel[0],
          labelColor:
            this.$getDeepObj(this.detail, 'tgl_monev') &&
            !this.form[`mapel-${mapelId}`] &&
            this.form[`mapel-${mapelId}`] !== 0
              ? 'red'
              : 'grey',
          hint: 'wajib diisi',
          placeholder: 'Tuliskan jumlah guru',
          mask: '###',
          grid: { cols: 12, md: 3 },
          outlined: true,
          dense: true,
          singleLine: true,
        });
      }

      let result = [
        {
          title: '<strong style="font-size: 18px">Form Kegiatan</strong>',
          grid: 12,
          instrumen: [
            {
              type: 'textView',
              label: `Nama Pelapor`,
              labelColor: 'grey',
              value: this.$getDeepObj(this.detail, 'ptk.nama') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `Nama Satuan Pendidikan/Sekolah`,
              labelColor: 'grey',
              value: this.$getDeepObj(this.detail, 'sekolah.nama') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `Kota/Kabupaten Satuan Pendidikan/Sekolah`,
              labelColor: 'grey',
              value: this.$getDeepObj(this.detail, 'sekolah.m_kota.keterangan') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'VDatePicker',
              name: 'tgl_monev',
              label: 'Tanggal Pembukaan IHT',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VSelect',
              name: 'k_monev_moda_psp',
              label: 'Moda Penyelenggaraan IHT',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              items: this.$mapForMaster(this.masters.monev_moda_psp || {}),
              itemText: 'text',
              itemValue: 'value',
              outlined: true,
              dense: true,
              singleLine: true,
            },
          ],
        },
      ];

      for (const idKelompok in kelompok) {
        if (kelompok[idKelompok] && kelompokMapels[idKelompok]) {
          result.push({
            title: +idKelompok === 0 ? '<strong style="font-size: 18px">Sasaran IHT</strong>' : '',
            subtitle: [
              `<div class="body-1 font-weight-medium ${+idKelompok === 0 ? 'mt-4' : ''}">${this.$numberToAlpha(
                idKelompok
              )}. ${kelompok[idKelompok]} (Jumlah Guru Mapel)</div>`,
              `<div class="body-2">Jika tidak ada guru mata pelajaran yang mengikuti, isikan angka 0 pada kolom</div>`,
            ].join(''),
            grid: 12,
            instrumen: kelompokMapels[idKelompok],
          });
        }
      }

      result.push({
        title: '<strong style="font-size: 18px">Dokumentasi Pembukaan IHT</strong>',
        grid: 12,
        type: 'File',
        instrumen: [
          {
            id: 1,
            type: 'File',
            name: 'file_dok1',
            label: 'Foto Kegiatan',
          },
          {
            id: 2,
            type: 'File',
            name: 'file_dok2',
            label: 'Foto Kegiatan',
          },
          {
            id: 3,
            type: 'File',
            name: 'file_dok3',
            label: 'Foto Kegiatan',
          },
        ],
      });
      result.push({
        title: '<strong style="font-size: 18px">Dokumentasi absensi IHT</strong>',
        grid: 12,
        type: 'File',
        instrumen: [
          {
            id: 4,
            type: 'File',
            name: 'file_presensi',
            label: 'Dokumentasi Absensi',
          },
        ],
      });

      return result;
    },

    schemaIhtTutupSmkPk() {
      return {
        1: [
          {
            title: '<strong style="font-size: 18px">Form Kegiatan</strong>',
            grid: 12,
            instrumen: [
              {
                type: 'textView',
                label: `Nama Pelapor`,
                labelColor: 'grey',
                value: this.$getDeepObj(this.detail, 'ptk.nama') || '',
                grid: { cols: 12, md: 6 },
              },
              {
                type: 'textView',
                label: `Nama Satuan Pendidikan/Sekolah`,
                labelColor: 'grey',
                value: this.$getDeepObj(this.detail, 'sekolah.nama') || '',
                grid: { cols: 12, md: 6 },
              },
              {
                type: 'textView',
                label: `Kota/Kabupaten Satuan Pendidikan/Sekolah`,
                labelColor: 'grey',
                value: this.$getDeepObj(this.detail, 'sekolah.m_kota.keterangan') || '',
                grid: { cols: 12, md: 6 },
              },
              {
                type: 'VDatePicker',
                name: 'tgl_monev',
                label: 'Tanggal Penutupan IHT',
                labelColor: 'grey',
                placeholder: 'Pilih tanggal',
                hint: 'wajib diisi',
                grid: { cols: 12, md: 6 },
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VTextarea',
                name: 'instrumen-psp_1',
                label: 'Latar belakang dan tujuan kegiatan',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_1'] ? 'red' : 'grey',
                placeholder: 'Tuliskan deskripsi latar belakang dan tujuan kegiatan',
                hint: 'wajib diisi',
                grid: { cols: 12 },
                outlined: true,
                dense: true,
                singleLine: true,
                rows: 3,
                autoGrow: true,
              },
            ],
          },
          {
            title: [
              '<strong style="font-size: 18px">Pihak Luar Satuan Pendidikan yang Hadir (Jumlah Orang)</strong>',
              '<span class="body-2">Jika tidak ada perwakilan pihak terkait yang mengikuti, isikan angka 0 pada kolom</span>',
            ].join('<br>'),
            grid: 12,
            instrumen: [
              {
                type: 'VTextField',
                name: 'jml_hadir_dinas',
                label: 'Perwakilan Dinas Pendidikan',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') &&
                  !this.form['jml_hadir_dinas'] &&
                  this.form['jml_hadir_dinas'] !== 0
                    ? 'red'
                    : 'grey',
                placeholder: 'Tuliskan angka',
                hint: 'wajib diisi',
                grid: { cols: 12, sm: 12, md: 3 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VTextField',
                name: 'jml_hadir_pengawas',
                label: 'Jml. Pengawas Sekolah',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') &&
                  !this.form['jml_hadir_pengawas'] &&
                  this.form['jml_hadir_pengawas'] !== 0
                    ? 'red'
                    : 'grey',
                placeholder: 'Tuliskan angka',
                hint: 'wajib diisi',
                grid: { cols: 12, sm: 12, md: 3 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VTextField',
                name: 'jml_hadir_upt',
                label: 'Perwakilan BBPPMPV',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') &&
                  !this.form['jml_hadir_upt'] &&
                  this.form['jml_hadir_upt'] !== 0
                    ? 'red'
                    : 'grey',
                placeholder: 'Tuliskan angka',
                hint: 'wajib diisi',
                grid: { cols: 12, sm: 12, md: 3 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VTextField',
                name: 'jml_hadir_fasilitator',
                label: 'Pendampingan Implementasi Pembelajaran',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') &&
                  !this.form['jml_hadir_fasilitator'] &&
                  this.form['jml_hadir_fasilitator'] !== 0
                    ? 'red'
                    : 'grey',
                placeholder: 'Tuliskan angka',
                hint: 'wajib diisi',
                grid: { cols: 12, sm: 12, md: 3 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VRadio',
                name: 'is_luar_hadir',
                label: 'Apakah ada pihak luar satuan pendidikan lainnya yang ikut hadir?',
                labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['is_luar_hadir'] ? 'red' : 'grey',
                hint: 'wajib diisi',
                required: true,
                items: [
                  { text: 'Ya', value: '1' },
                  { text: 'Tidak', value: '0' },
                ],
                grid: { cols: 12, md: 6 },
              },
              {
                show: { status: +this.form.is_luar_hadir === 1 },
                type: 'VTextField',
                name: 'nama_hadir_lain',
                label: 'Instansi pihak luar',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') &&
                  !this.form['nama_hadir_lain'] &&
                  this.form['nama_hadir_lain'] !== 0
                    ? 'red'
                    : 'grey',
                placeholder: 'Tuliskan angka',
                hint: 'wajib diisi',
                grid: { cols: 12, sm: 12, md: 3 },
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                show: { status: +this.form.is_luar_hadir === 1 },
                type: 'VTextField',
                name: 'jml_hadir_lain',
                label: 'Jumlah pihak luar lainnya',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') &&
                  !this.form['jml_hadir_lain'] &&
                  this.form['jml_hadir_lain'] !== 0
                    ? 'red'
                    : 'grey',
                hint: 'wajib diisi',
                grid: { cols: 12, sm: 12, md: 3 },
                mask: '###',
                outlined: true,
                dense: true,
                singleLine: true,
              },
            ],
          },
          {
            title:
              '<strong style="font-size: 18px">Hal-hal efektif dan tidak efektif terkait materi dan pelaksanaan IHT</strong>',
            grid: 12,
            instrumen: [
              {
                type: 'VTextarea',
                name: 'instrumen-psp_11',
                label: 'Hal-hal Efektif Terkait Konten/Materi',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_11'] ? 'red' : 'grey',
                placeholder: 'Tuliskan tentang Hal-hal Efektif Terkait Konten/Materi',
                hint: 'wajib diisi',
                grid: { cols: 12 },
                outlined: true,
                dense: true,
                singleLine: true,
                rows: 3,
                autoGrow: true,
              },
              {
                type: 'VTextarea',
                name: 'instrumen-psp_12',
                label: 'Hal-hal Efektif Terkait Pelaksanaan IHT',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_12'] ? 'red' : 'grey',
                placeholder: 'Tuliskan tentang Hal-hal Efektif Terkait Pelaksanaan IHT',
                hint: 'wajib diisi',
                grid: { cols: 12 },
                outlined: true,
                dense: true,
                singleLine: true,
                rows: 3,
                autoGrow: true,
              },
              {
                type: 'VTextarea',
                name: 'instrumen-psp_13',
                label: 'Hal-hal Tidak Efektif Terkait Konten/Materi',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_13'] ? 'red' : 'grey',
                placeholder: 'Tuliskan tentang Hal-hal Tidak Efektif Terkait Konten/Materi',
                hint: 'wajib diisi',
                grid: { cols: 12 },
                outlined: true,
                dense: true,
                singleLine: true,
                rows: 3,
                autoGrow: true,
              },
              {
                type: 'VTextarea',
                name: 'instrumen-psp_14',
                label: 'Hal-hal Tidak Efektif Terkait Pelaksanaan IHT (tuliskan kendala dan solusinya)',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_14'] ? 'red' : 'grey',
                placeholder: 'Tuliskan tentang Hal-hal Tidak Efektif Terkait Pelaksanaan IHT',
                hint: 'wajib diisi',
                grid: { cols: 12 },
                outlined: true,
                dense: true,
                singleLine: true,
                rows: 3,
                autoGrow: true,
              },
              {
                type: 'VTextarea',
                name: 'instrumen-psp_15',
                label: 'Rencana Tindak Lanjut IHT',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_15'] ? 'red' : 'grey',
                placeholder: 'Tuliskan tentang Rencana Tindak Lanjut IHT',
                hint: 'wajib diisi',
                grid: { cols: 12 },
                outlined: true,
                dense: true,
                singleLine: true,
                rows: 3,
                autoGrow: true,
              },
            ],
          },
          {
            title: '<strong style="font-size: 18px">Hambatan dan Dukungan</strong>',
            grid: 12,
            instrumen: [
              {
                type: 'VTextarea',
                name: 'instrumen-psp_16',
                label: 'Hambatan yang ditemui selama proses IHT',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_16'] ? 'red' : 'grey',
                placeholder: 'Tuliskan tentang Hambatan yang ditemui selama proses IHT',
                hint: 'wajib diisi',
                grid: { cols: 12 },
                outlined: true,
                dense: true,
                singleLine: true,
                rows: 3,
                autoGrow: true,
              },
              {
                type: 'VTextarea',
                name: 'instrumen-psp_17',
                label: 'Dukungan yang diperlukan agar proses IHT semakin baik',
                labelColor:
                  this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_17'] ? 'red' : 'grey',
                placeholder: 'Tuliskan tentang Dukungan yang diperlukan agar proses IHT semakin baik',
                hint: 'wajib diisi',
                grid: { cols: 12 },
                outlined: true,
                dense: true,
                singleLine: true,
                rows: 3,
                autoGrow: true,
              },
            ],
          },
          {
            title: '<strong style="font-size: 18px">Dokumentasi Foto Proses IHT</strong>',
            grid: 12,
            type: 'File',
            instrumen: [
              {
                id: 1,
                type: 'File',
                name: 'file_dok1',
                label: 'Foto Kegiatan',
              },
              {
                id: 2,
                type: 'File',
                name: 'file_dok2',
                label: 'Foto Kegiatan',
              },
              {
                id: 3,
                type: 'File',
                name: 'file_dok3',
                label: 'Foto Kegiatan',
              },
            ],
          },
          {
            title: '<strong style="font-size: 18px">Dokumentasi absensi IHT</strong>',
            grid: 12,
            type: 'File',
            instrumen: [
              {
                id: 4,
                type: 'File',
                name: 'file_presensi',
                label: 'Dokumentasi Absensi',
              },
            ],
          },
        ],
        2: [
          {
            title:
              '<strong style="font-size: 18px"> Rekapitulasi Instrumen evaluasi penyelenggaraan IHT</strong>' +
              '<br/> Isikan <b>Jumlah data</b> instrumen berikut berdasarkan kategori <b>Sangat Tidak Setuju, ' +
              'Tidak Setuju, Setuju, </b> dan <b>Sangat Setuju.</b>' +
              '<br/> Jika tidak ada data untuk kolom kategori yang disediakan, tuliskan <strong>angka 0</strong>',
            grid: 12,
            type: 'rekapitulasi',
            rekaps: [
              {
                label: 'A. Instrumen Umpan Balik Pengajar IHT',
                children: [
                  {
                    label: 'Persepsi Peserta IHT terhadap Kualitas Narasumber',
                    questions: {
                      201: 'Penyampaian materi yang diberikan menarik',
                      202: 'Pengajar menguasai materi IHT',
                      203: 'Pengajar mampu menyampaikan materi sehingga mudah dipahami.',
                      204: 'Pengajar memberikan umpan balik (feedback) yang membantu peserta untuk lebih memahami materi yang diajarkan',
                      205: 'Pengajar memberikan kesempatan bertanya dan berdiskusi.',
                      206: 'Pengajar melakukan asesmen yang dilakukan oleh pengajar sesuai dengan tujuan IHT',
                      207: 'Pengajar memiliki manajemen waktu pembelajaran yang baik',
                      208: 'Pengajar mampu menjawab pertanyaan-pertanyaan yang diajukan oleh peserta IHT',
                      209: 'Pengajar mampu memberikan motivasi kepada peserta IHT',
                    },
                  },
                ],
              },
              {
                label: 'B. Instrumen Umpan Balik Proses Penyelenggaraan IHT',
                children: [
                  {
                    label: 'Persepsi Terkait Metode IHT',
                    questions: {
                      210: 'Metode yang di gunakan dapat secara efektif meningkatkan pemahaman dan keterampilan.',
                      211: 'Secara umum, durasi pelaksanaan IHT mencukupi.',
                      212: 'Selama pelaksanaan IHT, terjadi interaksi antar peserta untuk meningkatkan keterampilan dan pengetahuan.',
                      213: 'Keterampilan yang diperoleh selama pelaksanaan IHT relevan dengan tugas saya sebagai pelaksana program di satuan pendidikan',
                      214: 'Kegiatan praktik dalam pelaksanaan IHT memiliki kesesuaian dengan konsep/teori yang diajarkan.',
                      215: 'Teknik penyampaian materi melalui eksplorasi konsep yang dilanjutkan dengan diskusi (pembelajaran alur MERRDEKA) memudahkan saya dalam memahami materi IHT',
                    },
                  },
                  {
                    label: 'Perangkat Ajar IHT',
                    questions: {
                      216: 'Panduan IHT yang diberikan berisi informasi yang dibutuhkan oleh peserta',
                      217: 'Modul IHT mudah untuk diakses/diunduh.',
                      218: 'Platform pembelajaran IHT membantu saya memahami materi.',
                    },
                  },
                  {
                    label: 'Substansi/Materi IHT',
                    questions: {
                      219: 'Secara umum, materi IHT cukup mudah dipahami',
                      220: 'Materi IHT menyiapkan saya dalam meningkatkan kualitas pembelajaran kepada peserta didik',
                      221: 'Materi IHT dapat menjawab permasalahan di tingkat satuan pendidikan',
                    },
                  },
                ],
              },
            ],
            options: [
              {
                type: 'VTextField',
                name: 'n1',
                label: 'Sangat Tidak Setuju',
                labelColor: 'red',
                placeholder: 'Tuliskan angka',
                grid: { cols: 12, sm: 12, md: 3 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
                hideDetails: true,
              },
              {
                type: 'VTextField',
                name: 'n2',
                label: 'Tidak Setuju',
                labelColor: 'warning',
                placeholder: 'Tuliskan angka',
                grid: { cols: 12, sm: 12, md: 3 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VTextField',
                name: 'n3',
                label: 'Setuju',
                labelColor: 'blue',
                placeholder: 'Tuliskan angka',
                grid: { cols: 12, sm: 12, md: 3 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
              },
              {
                type: 'VTextField',
                name: 'n4',
                label: 'Sangat Setuju',
                labelColor: 'green',
                placeholder: 'Tuliskan angka',
                grid: { cols: 12, sm: 12, md: 3 },
                mask: '######',
                outlined: true,
                dense: true,
                singleLine: true,
              },
            ],
          },
        ],
      };
    },

    schemaIhtAdministrasi() {
      return [
        {
          title: '<strong style="font-size: 18px">Laporan Administrasi Pelaksanaan IHT</strong>',
          grid: 12,
          type: 'File',
          instrumen: [
            {
              id: 4,
              type: 'File',
              name: 'file_presensi',
              label: 'Dokumen Presensi Peserta selama proses kegiatan IHT',
            },
            {
              id: 5,
              type: 'File',
              name: 'file_konsumsi',
              label: 'Dokumen kuitansi konsumsi selama proses kegiatan IHT',
            },
          ],
        },
      ];
    },

    schemaMeetings() {
      return [
        {
          type: 'VTextField',
          name: 'url_meeting',
          label: 'Rekaman Video Conference (jika ada) taruh URL, video rekaman disini',
          labelColor: 'grey',
          hint: '',
          required: true,
          grid: { cols: 12, md: 12, sm: 12 },
          outlined: true,
          singleLine: true,
          dense: true,
          readonly: this.readOnly,
          prependInnerIcon: 'mdi-video',
        },
      ];
    },

    schemaIhtAwal() {
      const dasar = {
        title: '<strong style="font-size: 18px">Form Kegiatan</strong>',
        grid: 12,
        instrumen: [
          {
            type: 'textView',
            label: `Nama Pelapor`,
            labelColor: 'grey',
            value: this.$getDeepObj(this.detail, 'ptk.nama') || '',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: `Nama Satuan Pendidikan`,
            labelColor: 'grey',
            value: this.$getDeepObj(this.detail, 'sekolah.nama') || '',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: `Jenjang Satuan Pendidikan`,
            labelColor: 'grey',
            value: this.$getDeepObj(this.detail, 'sekolah.m_jenjang.singkat') || '',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: `NPSN`,
            labelColor: 'grey',
            value: this.$getDeepObj(this.detail, 'sekolah.npsn') || '',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: `Kota/Kabupaten Satuan Pendidikan`,
            labelColor: 'grey',
            value: this.$getDeepObj(this.detail, 'sekolah.m_kota.keterangan') || '',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: `Provinsi Satuan Pendidikan`,
            labelColor: 'grey',
            value: this.$getDeepObj(this.detail, 'sekolah.m_propinsi.keterangan') || '',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'VRadio',
            name: 'is_terlaksana',
            label: 'Apakah menyelenggarakan IHT di satuan pendidikan?',
            labelColor: 'grey',
            hint: 'wajib diisi',
            required: true,
            disabled: this.readOnly,
            items: [
              { text: 'Ya', value: '1' },
              { text: 'Tidak', value: '0' },
            ],
            grid: { cols: 12 },
          },
          {
            exist: { status: +this.form.is_terlaksana === 1 },
            type: 'VDatePicker',
            name: 'tgl_monev',
            label: 'Tanggal Mulai Pelaksanaan IHT',
            labelColor: 'grey',
            hint: 'wajib diisi',
            grid: { cols: 12, md: 6 },
            outlined: true,
            dense: true,
            singleLine: true,
            disabled: this.readOnly,
          },
          {
            exist: { status: +this.form.is_terlaksana === 1 },
            type: 'VSelect',
            name: 'k_monev_moda_psp',
            label: 'Moda Penyelenggaraan IHT',
            labelColor: 'grey',
            hint: 'wajib diisi',
            grid: { cols: 12, md: 6 },
            items: this.$mapForMaster(this.masters.monev_moda_psp || {}),
            itemText: 'text',
            itemValue: 'value',
            outlined: true,
            dense: true,
            singleLine: true,
            disabled: this.readOnly,
          },
          {
            exist: { status: +this.form.is_terlaksana === 0 && this.form.is_terlaksana !== null },
            type: 'VSelect',
            name: 'k_monev_alasan_psp',
            label: 'Alasan tidak menyelenggarakan IHT',
            labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['k_monev_alasan_psp'] ? 'red' : 'grey',
            hint: 'wajib diisi',
            grid: { cols: 12, md: 6 },
            items: this.mMonevAlasanPsp,
            itemText: 'text',
            itemValue: 'value',
            outlined: true,
            dense: true,
            singleLine: true,
            disabled: this.readOnly,
          },
          {
            exist: { status: +this.form.is_terlaksana === 0 && +this.form.k_monev_alasan_psp === 9 },
            type: 'VTextField',
            name: 'alasan_lain',
            label: 'Alasan lainnya tidak menyelenggarakan IHT',
            labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['alasan_lain'] ? 'red' : 'grey',
            hint: 'wajib diisi',
            grid: { cols: 12, md: 6 },
            outlined: true,
            dense: true,
            singleLine: true,
            required: +this.form.is_terlaksana === 0 && +this.form.k_monev_alasan_psp === 9,
            disabled: this.readOnly,
          },
        ],
      };
      const rekaman = {
        title: '<strong style="font-size: 18px">Link Rekaman</strong>',
        grid: 12,
        type: 'rekaman',
        max: 1,
        hideOnMax: true,
      };
      const berkas = {
        title: '<strong style="font-size: 18px">Dokumentasi Pembukaan IHT</strong>',
        label: 'Dokumen Pembukaan IHT',
        grid: 12,
        type: 'berkas',
        k_monev_berkas_psp: 6,
        key: 'file_dokawal',
        min: 2,
        max: 10,
        hideOnMax: true,
      };
      const pretest = {
        title: '',
        type: 'link',
        instrumen: [
          {
            type: 'link',
            color: 'blue',
            content: [
              '<h2 class="black--text">Informasi Tambahan</h2>',
              `<p class="black--text mt-2">Untuk mengakses tautan pre test sesuai UPT Anda, silakan akses pada <a href="${this
                .detail && this.detail.url_pretest}" target="_blank">${this.detail && this.detail.url_pretest}</a></p>`,
            ].join(''),
          },
        ],
      };

      return {
        1: [
          dasar,
          +this.form.is_terlaksana === 1 && [1, 3].includes(+this.form.k_monev_moda_psp) ? rekaman : { hidden: true },
          +this.form.is_terlaksana === 1 ? berkas : { hidden: true },
          +this.form.is_terlaksana === 1 && this.detail && this.detail.url_pretest ? pretest : { hidden: true },
        ],
      };
    },

    schemaIhtAkhir() {
      return [
        {
          title: '<strong style="font-size: 18px">Form Kegiatan</strong>',
          grid: 12,
          instrumen: [
            {
              type: 'textView',
              label: `Nama Pelapor`,
              labelColor: 'grey',
              value: this.$getDeepObj(this.detail, 'ptk.nama') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `Nama Satuan Pendidikan`,
              labelColor: 'grey',
              value: this.$getDeepObj(this.detail, 'sekolah.nama') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `Jenjang Satuan Pendidikan`,
              labelColor: 'grey',
              value: this.$getDeepObj(this.detail, 'sekolah.m_jenjang.singkat') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `NPSN`,
              labelColor: 'grey',
              value: this.$getDeepObj(this.detail, 'sekolah.npsn') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `Kota/Kabupaten Satuan Pendidikan`,
              labelColor: 'grey',
              value: this.$getDeepObj(this.detail, 'sekolah.m_kota.keterangan') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `Provinsi Satuan Pendidikan`,
              labelColor: 'grey',
              value: this.$getDeepObj(this.detail, 'sekolah.m_propinsi.keterangan') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'VDatePicker',
              name: 'tgl_monev',
              label: 'Tanggal Penutupan IHT',
              placeholder: 'Pilih tanggal penutupan IHT',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
              disabled: this.readOnly,
            },
            {
              type: 'VSelect',
              name: 'k_monev_moda_psp',
              label: 'Moda Penyelenggaraan IHT',
              labelColor: 'grey',
              placeholder: 'Piih moda penyelenggaraan',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              items: this.$mapForMaster(this.masters.monev_moda_psp || {}),
              itemText: 'text',
              itemValue: 'value',
              outlined: true,
              dense: true,
              singleLine: true,
              disabled: this.readOnly,
            },
          ],
        },
        {
          title: [
            '<strong style="font-size: 18px">Pihak Luar Satuan Pendidikan yang Hadir (Jumlah Orang)</strong>',
            '<span class="body-2">Jika tidak ada perwakilan pihak terkait yang mengikuti, isikan angka 0 pada kolom</span>',
          ].join('<br>'),
          grid: 12,
          instrumen: [
            {
              type: 'VTextField',
              name: 'jml_hadir_dinas',
              label: 'Perwakilan Dinas Pendidikan',
              labelColor:
                this.$getDeepObj(this.detail, 'tgl_monev') &&
                !this.form['jml_hadir_dinas'] &&
                this.form['jml_hadir_dinas'] !== 0
                  ? 'red'
                  : 'grey',
              placeholder: 'Total perwakilan dari Dinas',
              hint: 'wajib diisi',
              grid: { cols: 12, sm: 12, md: 3 },
              mask: '######',
              outlined: true,
              dense: true,
              singleLine: true,
              disabled: this.readOnly,
            },
            {
              type: 'VTextField',
              name: 'jml_hadir_pengawas',
              label: 'Jml. Pengawas Sekolah',
              labelColor:
                this.$getDeepObj(this.detail, 'tgl_monev') &&
                !this.form['jml_hadir_pengawas'] &&
                this.form['jml_hadir_pengawas'] !== 0
                  ? 'red'
                  : 'grey',
              hint: 'wajib diisi',
              placeholder: 'Total perwakilan dari Pengawas',
              grid: { cols: 12, sm: 12, md: 3 },
              mask: '######',
              outlined: true,
              dense: true,
              singleLine: true,
              disabled: this.readOnly,
            },
            {
              type: 'VTextField',
              name: 'jml_hadir_upt',
              label: 'Perwakilan UPT/BGP/BBGP',
              labelColor:
                this.$getDeepObj(this.detail, 'tgl_monev') &&
                !this.form['jml_hadir_upt'] &&
                this.form['jml_hadir_upt'] !== 0
                  ? 'red'
                  : 'grey',
              placeholder: 'Total perwakilan dari BGP / BBGP',
              hint: 'wajib diisi',
              grid: { cols: 12, sm: 12, md: 3 },
              mask: '######',
              outlined: true,
              dense: true,
              singleLine: true,
              disabled: this.readOnly,
            },
            {
              type: 'VTextField',
              name: 'jml_hadir_fasilitator',
              label: 'Fasilitator Sekolah Penggerak',
              labelColor:
                this.$getDeepObj(this.detail, 'tgl_monev') &&
                !this.form['jml_hadir_fasilitator'] &&
                this.form['jml_hadir_fasilitator'] !== 0
                  ? 'red'
                  : 'grey',
              placeholder: 'Total perwakilan dari Fasilitator',
              hint: 'wajib diisi',
              grid: { cols: 12, sm: 12, md: 3 },
              mask: '######',
              outlined: true,
              dense: true,
              singleLine: true,
              disabled: this.readOnly,
            },
            {
              type: 'VRadio',
              name: 'is_luar_hadir',
              label: 'Apakah ada pihak luar satuan pendidikan lainnya yang ikut hadir?',
              labelColor: this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['is_luar_hadir'] ? 'red' : 'grey',
              hint: 'wajib diisi',
              required: true,
              disabled: this.readOnly,
              items: [
                { text: 'Ya', value: '1' },
                { text: 'Tidak', value: '0' },
              ],
              grid: { cols: 12, md: 6 },
            },
            {
              show: { status: +this.form.is_luar_hadir === 1 },
              type: 'VTextField',
              name: 'nama_hadir_lain',
              label: 'Instansi pihak luar',
              labelColor:
                this.$getDeepObj(this.detail, 'tgl_monev') &&
                !this.form['nama_hadir_lain'] &&
                this.form['nama_hadir_lain'] !== 0
                  ? 'red'
                  : 'grey',
              hint: 'wajib diisi',
              placeholder: 'Tuliskan nama',
              grid: { cols: 12, sm: 12, md: 3 },
              outlined: true,
              dense: true,
              singleLine: true,
              disabled: this.readOnly,
            },
            {
              show: { status: +this.form.is_luar_hadir === 1 },
              type: 'VTextField',
              name: 'jml_hadir_lain',
              label: 'Jumlah pihak luar lainnya',
              labelColor:
                this.$getDeepObj(this.detail, 'tgl_monev') &&
                !this.form['jml_hadir_lain'] &&
                this.form['jml_hadir_lain'] !== 0
                  ? 'red'
                  : 'grey',
              hint: 'wajib diisi',
              placeholder: 'Total pihak luar',
              grid: { cols: 12, sm: 12, md: 3 },
              mask: '###',
              outlined: true,
              dense: true,
              singleLine: true,
              disabled: this.readOnly,
            },
          ],
        },
        {
          title: '<strong style="font-size: 18px">Refleksi Pelaksanaan Kegiatan</strong>',
          subtitle: '&nbsp;',
          subtitleClass: 'mt-2',
          grid: 12,
          children: [
            {
              grid: 12,
              instrumen: [
                {
                  type: 'VTextarea',
                  name: 'instrumen-psp_3',
                  label: 'Hal baru yang dipelajari dari IHT',
                  labelColor:
                    this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_3'] ? 'red' : 'grey',
                  placeholder: 'Deskripsikan hal baru yang dipelajari dari IHT (min. 10 karakter)',
                  hint: 'wajib diisi (min. 10 karakter)',
                  grid: { cols: 12 },
                  outlined: true,
                  dense: true,
                  singleLine: true,
                  disabled: this.readOnly,
                  rows: 3,
                },
              ],
            },
          ],
        },
        {
          subtitle:
            '<span class="px-0 body-2 grey--text" style="height: 24px;">Hal-hal Efektif Terkait Konten/Materi</span>',
          grid: 12,
          children: [
            {
              grid: 3,
              instrumen: [
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_21_21',
                  value: 21,
                  trueValue: 21,
                  falseValue: '',
                  label: 'Contoh Materi',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_21_22',
                  value: 22,
                  trueValue: 22,
                  falseValue: '',
                  label: 'Durasi',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 3,
              instrumen: [
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_21_23',
                  value: 23,
                  trueValue: 23,
                  falseValue: '',
                  label: 'Media audio visual materi',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_21_24',
                  value: 24,
                  trueValue: 24,
                  falseValue: '',
                  label: 'Konten Materi',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 3,
              instrumen: [
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_21_25',
                  value: 25,
                  trueValue: 25,
                  falseValue: '',
                  label: 'Akses Materi',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_21_26',
                  value: 26,
                  trueValue: 26,
                  falseValue: '',
                  label: 'Bahasa Materi',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 3,
              instrumen: [
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_21_27',
                  value: 27,
                  trueValue: 27,
                  falseValue: '',
                  label: 'Lainnya',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 12,
              instrumen: [
                {
                  type: 'VTextarea',
                  name: 'instrumen-psp_22',
                  label: '',
                  labelColor:
                    this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_22'] ? 'red' : 'grey',
                  placeholder: 'Tuliskan tentang Hal-hal Efektif Terkait Konten/Materi (min. 10 karkter)',
                  hint: 'wajib diisi (min. 10 karkter)',
                  grid: { cols: 12 },
                  outlined: true,
                  dense: true,
                  singleLine: false,
                  hideDetails: true,
                  rows: 3,
                  autoGrow: true,
                  disabled: this.readOnly,
                },
              ],
            },
          ],
        },
        {
          grid: 12,
          subtitle:
            '<span class="px-0 body-2 grey--text" style="height: 24px;">Hal-hal Efektif Terkait Pelaksanaan IHT</span>',
          children: [
            {
              grid: 3,
              instrumen: [
                {
                  id: '1',
                  type: 'Checkbox',
                  name: 'opsi-psp_23_31',
                  value: 31,
                  trueValue: 31,
                  falseValue: '',
                  label: 'Tempat',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 3,
              instrumen: [
                {
                  id: '2',
                  type: 'Checkbox',
                  name: 'opsi-psp_23_32',
                  value: 32,
                  trueValue: 32,
                  falseValue: '',
                  label: 'Waktu',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 3,
              instrumen: [
                {
                  id: '3',
                  type: 'Checkbox',
                  name: 'opsi-psp_23_33',
                  value: 33,
                  trueValue: 33,
                  falseValue: '',
                  label: 'Kepadatan Acara',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 3,
              instrumen: [
                {
                  id: '4',
                  type: 'Checkbox',
                  name: 'opsi-psp_23_34',
                  value: 34,
                  trueValue: 34,
                  falseValue: '',
                  label: 'Lainnya',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 12,
              instrumen: [
                {
                  type: 'VTextarea',
                  name: 'instrumen-psp_24',
                  label: '',
                  labelColor:
                    this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_24'] ? 'red' : 'grey',
                  placeholder: 'Tuliskan tentang Hal-hal Efektif Terkait Pelaksanaan IHT (min. 10 karkter)',
                  hint: 'wajib diisi (min. 10 karkter)',
                  grid: { cols: 12 },
                  outlined: true,
                  dense: true,
                  singleLine: false,
                  hideDetails: true,
                  disabled: this.readOnly,
                  rows: 3,
                  autoGrow: true,
                },
              ],
            },
          ],
        },
        {
          grid: 12,
          subtitle:
            '<span class="px-0 body-2 grey--text" style="height: 24px;">Hal-hal Belum Efektif Terkait Konten/Materi</span>',
          children: [
            {
              grid: 3,
              instrumen: [
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_25_41',
                  value: 41,
                  trueValue: 41,
                  falseValue: '',
                  label: 'Contoh Materi',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_25_42',
                  value: 42,
                  trueValue: 42,
                  falseValue: '',
                  label: 'Durasi',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 3,
              instrumen: [
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_25_43',
                  value: 43,
                  trueValue: 43,
                  falseValue: '',
                  label: 'Media audio visual materi',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_25_44',
                  value: 44,
                  trueValue: 44,
                  falseValue: '',
                  label: 'Konten Materi',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 3,
              instrumen: [
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_25_45',
                  value: 45,
                  trueValue: 45,
                  falseValue: '',
                  label: 'Akses Materi',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_25_46',
                  value: 46,
                  trueValue: 46,
                  falseValue: '',
                  label: 'Bahasa Materi',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 3,
              instrumen: [
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_25_47',
                  value: 47,
                  trueValue: 47,
                  falseValue: '',
                  label: 'Lainnya',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 12,
              instrumen: [
                {
                  type: 'VTextarea',
                  name: 'instrumen-psp_26',
                  label: '',
                  labelColor:
                    this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_26'] ? 'red' : 'grey',
                  placeholder: 'Tuliskan tentang Hal-hal Belum Efektif Terkait Konten/Materi (min. 10 karkter)',
                  hint: 'wajib diisi (min. 10 karkter)',
                  subHint: false,
                  grid: { cols: 12 },
                  outlined: true,
                  dense: true,
                  singleLine: false,
                  hideDetails: true,
                  disabled: this.readOnly,
                  rows: 3,
                  autoGrow: true,
                },
              ],
            },
          ],
        },
        {
          grid: 12,
          subtitle:
            '<span class="px-0 body-2 grey--text" style="height: 24px;">Hal-hal Tidak Efektif Terkait Pelaksanaan IHT</span>',
          children: [
            {
              grid: 3,
              instrumen: [
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_27_51',
                  value: 51,
                  trueValue: 51,
                  falseValue: '',
                  label: 'Tempat',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 3,
              instrumen: [
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_27_52',
                  value: 52,
                  trueValue: 52,
                  falseValue: '',
                  label: 'Waktu',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 3,
              instrumen: [
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_27_53',
                  value: 53,
                  trueValue: 53,
                  falseValue: '',
                  label: 'Kepadatan Acara',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 3,
              instrumen: [
                {
                  type: 'Checkbox',
                  name: 'opsi-psp_27_54',
                  value: 54,
                  trueValue: 54,
                  falseValue: '',
                  label: 'Lainnya',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  disabled: this.readOnly,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 12,
              instrumen: [
                {
                  type: 'VTextarea',
                  name: 'instrumen-psp_28',
                  label: '',
                  labelColor:
                    this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_28'] ? 'red' : 'grey',
                  placeholder: 'Tuliskan tentang Hal-hal Tidak Efektif Terkait Pelaksanaan IHT (min. 10 karkter)',
                  hint: 'wajib diisi (min. 10 karkter)',
                  grid: { cols: 12 },
                  outlined: true,
                  dense: true,
                  singleLine: false,
                  hideDetails: true,
                  disabled: this.readOnly,
                  rows: 3,
                  autoGrow: true,
                },
              ],
            },
          ],
        },
        {
          grid: 12,
          children: [
            {
              grid: 12,
              instrumen: [
                {
                  type: 'VTextarea',
                  name: 'instrumen-psp_15',
                  label: 'Rencana Tindak Lanjut IHT',
                  labelColor:
                    this.$getDeepObj(this.detail, 'tgl_monev') && !this.form['instrumen-psp_15'] ? 'red' : 'grey',
                  placeholder: 'Tuliskan tentang Rencana Tindak Lanjut IHT (min. 10 karkter)',
                  hint: 'wajib diisi (min. 10 karkter)',
                  grid: { cols: 12 },
                  outlined: true,
                  dense: true,
                  singleLine: true,
                  disabled: this.readOnly,
                  rows: 3,
                  autoGrow: true,
                },
              ],
            },
          ],
        },
        {
          title: '<strong style="font-size: 18px">Dokumentasi Pelaksanaan IHT</strong>',
          label: 'Dokumen Pelaksanaan IHT',
          grid: 12,
          type: 'berkas',
          min: 2,
          max: 10,
          k_monev_berkas_psp: 7,
          key: 'file_dokakhir',
          hideOnMax: true,
        },

        {
          title: '<strong style="font-size: 18px">Dokumentasi daftar hadir IHT</strong>',
          label: 'Dokumen Presensi IHT',
          grid: 12,
          type: 'berkas',
          min: 1,
          max: 1,
          k_monev_berkas_psp: 4,
          key: 'presensi',
          hideOnMax: true,
        },
        [1, 3].includes(+this.form.k_monev_moda_psp)
          ? {
              title: '<strong style="font-size: 18px">Link Rekaman</strong>',
              grid: 12,
              type: 'rekaman',
              max: 1,
              hideOnMax: true,
            }
          : { hidden: true },
      ];
    },
  },
};
